import * as yup from 'yup';

export const editAICriteriaSetValidation = yup.object({
  client: yup.mixed().test('required', 'Client is required', (v: any) => !!v?.id),
  group: yup.mixed().nullable().optional(),
  categories: yup
    .array()
    .of(
      yup.object({
        id: yup.string(),
        name: yup.string().required('Category name is required'),
        color: yup.string().required('Category color is required'),
        order: yup.number().required(),
      })
    )
    // A group set can have zero of its OWN categories — it inherits the client's categories (and may
    // only hide inherited items or add criteria under inherited categories). Only a client-level set
    // (no group selected) must define at least one category of its own.
    .when('group', {
      is: (group: unknown) => !!group,
      then: (schema) => schema,
      otherwise: (schema) => schema.min(1, 'At least one category is required'),
    }),
});
